/**
 * Created by hao.cheng on 2017/4/16.
 */
import axios from 'axios';
import { get } from './tools';
import {Modal} from 'antd';
import * as config from './config';
import { message } from 'antd';
export const getPros = () => axios.post('/admin/index/order-list.htm', {
    category: "trending",
    period: "day",
    lang: "javascript",
    offset: 0,
    limit: 30
}).then(function (response) {
    return response.data;
}).catch(function (error) {
    console.log(error);
});
export const getBeforeUrl = () =>{
    let url;
    if(process.env.NODE_ENV=="development"){
        url="http://test-api.feima666.com";
    }else if(process.env.NODE_ENV=="production"){
        url="http://api.feima666.com";
    }
    return url;
}
export const getBeforeUploadUrl = () =>{
    let url;
    if(process.env.NODE_ENV=="development"){
        url="http://test-api.feima666.com";
    }else if(process.env.NODE_ENV=="production"){
        url="http://api.feima666.com";
    }
    return url;
}

export const getBeforeWsUrl = () =>{
    let url;
    if(process.env.NODE_ENV=="development"){
        url="http://test-ws.feima666.com";
    }else if(process.env.NODE_ENV=="production"){
        url="http://ws.feima666.com";
    }
    return url;
}



export const post = (url, data, headers) =>
    axios.post(getBeforeUrl()+url, data, {
      method: 'post',withCredentials: true,transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret

        }],
    }).then((res) =>res.data).catch(err => {
        console.log(err);
    });

export const statisticPost = (url, data, headers) =>
    axios.post(url, data, {
        method: 'post',withCredentials: true,transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret

        }],
    }).then((res) =>res.data).catch(err => {
        console.log(err);
    });

//withCredentials跨域
export const upload = ({url, data, msg = '接口异常', headers}) =>
    axios.post(getBeforeUrl()+url, data, {
        headers:{'Content-Type':'multipart/form-data'}, method: 'post',withCredentials: true
    },()=>{
    }).then(res => res.data).catch(err => {
        message.warn(msg);
    });


export const npmDependencies = () => axios.get('./npm.json').then(res => res.data).catch(err => console.log(err));

export const weibo = () => axios.get('./weibo.json').then(res => res.data).catch(err => console.log(err));

const GIT_OAUTH = 'https://github.com/login/oauth';
export const gitOauthLogin = () => axios.get(`${GIT_OAUTH}/authorize?client_id=792cdcd244e98dcd2dee&redirect_uri=http://localhost:3006/&scope=user&state=reactAdmin`);
export const gitOauthToken = code => axios.post('https://cors-anywhere.herokuapp.com/' + GIT_OAUTH + '/access_token', {...{client_id: '792cdcd244e98dcd2dee',
    client_secret: '81c4ff9df390d482b7c8b214a55cf24bf1f53059', redirect_uri: 'http://localhost:3006/', state: 'reactAdmin'}, code: code}, {headers: {Accept: 'application/json'}})
    .then(res => res.data).catch(err => console.log(err));
export const gitOauthInfo = access_token => axios({
    method: 'get',
    url: 'https://api.github.com/user?access_token=' + access_token,
}).then(res => res.data).catch(err => console.log(err));

// easy-mock数据交互
// 管理员权限获取
export const admin = () => get({url: config.MOCK_AUTH_ADMIN});

// 访问权限获取admin
export const guest = () => get({url: config.MOCK_AUTH_VISITOR});


// WEBPACK FOOTER //
// ./src/axios/index.js